module.exports = __webpack_public_path__ + "leboncoin-logo.png?6c789d5b2494b43f31f8c96dd6f5820d";